import IndexModel from "@/service/v10/sigap/IndexModel";
// import * as CryptoJS from 'crypto-js';
// const ID_TURMAS = "turmas" as string;
// import moment  from 'moment'; 
 
class MatriculaService extends IndexModel { 
      
    constructor() {
        super(); 
        this.url =  this.url + '/Matricula' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
  
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public getAll( search:any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '?' + search    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getHistorico( id, search:any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id + '/Historico?' + search    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
   
     
}
  
export default MatriculaService; 
